import React from 'react'
import { Link } from 'gatsby'

import { Navbar, Nav } from 'react-bootstrap'

import Logo from '../../img/logo-ganztags.png'

const CustomNavbar = ({ pageInfo, location }) => {
  return (
    <Navbar expand="lg" className="p-0 text-center">
      <Navbar.Brand className="p-0">
        <Link to="/en/">
          <img src={Logo} width="187" height="99" alt="ganztags. Logo" />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="navbar-nav ml-auto small pl-4">
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link
              to="/en/services"
              id="services"
              className={`nav-link ${location.pathname.includes('/services') ? 'active' : ''}`}
            >
              Services
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link
              to="/en/team/"
              className={`nav-link ${location.pathname.includes('/team') ? 'active' : ''}`}
              id="about"
            >
              About us
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link
              to="/en/clients/"
              className={`nav-link ${location.pathname.includes('/clients') ? 'active' : ''}`}
              id="kunden"
            >
              Clients
            </Link>
          </li>
          <li className="nav-item mr-3 pt-2 pt-md-0">
            <Link
              to="/en/careers/"
              className={`nav-link ${
                location.pathname.includes('/careers') || location.pathname.includes('/jobs') ? 'active' : ''
              }`}
              id="jobs"
            >
              Careers
            </Link>
          </li>
        </Nav>
        <Link to="/en/contact/" className="btn btn-primary text-uppercase text-white ml-lg-4 mb-4 mb-lg-0">
          Contact
        </Link>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default CustomNavbar
